import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

interface ManifestEntry {
  id: string;
  title: string;
  date: string;
  hashtags: string[];
  image: string | null;
  banner: string | null;
  status: "published" | "unpublished" | "archived";
}

interface BlogIndexProps {
  filterHashtag?: string;
  pageSize?: number;
}

const BlogIndex: React.FC<BlogIndexProps> = ({
  filterHashtag,
  pageSize = 5,
}) => {
  const [manifest, setManifest] = useState<ManifestEntry[]>([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const bucket = process.env.REACT_APP_FIREBASE_BUCKET;
  const contentPath = process.env.REACT_APP_CONTENT_PATH;

  useEffect(() => {
    if (!bucket || !contentPath) {
      setError("Firebase environment variables are not set.");
      setLoading(false);
      return;
    }

    const manifestUrl = `https://storage.googleapis.com/${bucket}/${encodeURIComponent(
      contentPath + "/manifest.json"
    )}`;

    setLoading(true);
    fetch(manifestUrl)
      .then((res) => res.json())
      .then((data: ManifestEntry[]) => {
        const published = data
          .filter((entry) => entry.status === "published")
          .sort(
            (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
          );
        setManifest(published);
      })
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [bucket, contentPath]);

  const filtered = filterHashtag
    ? manifest.filter((entry) => entry.hashtags.includes(filterHashtag))
    : manifest;

  const totalPages = Math.ceil(filtered.length / pageSize);
  const currentPosts = filtered.slice((page - 1) * pageSize, page * pageSize);

  if (loading)
    return <div className="alert alert-info text-center">Loading...</div>;
  if (error)
    return <div className="alert alert-danger text-center">Error: {error}</div>;
  if (currentPosts.length === 0)
    return (
      <div className="alert alert-warning text-center">No posts found.</div>
    );

  return (
    <div className="container mt-5 p-0">
      {currentPosts.map((post) => (
        <div key={post.id} className="card mb-3">
          {post.banner && (
            <img
              src={post.banner}
              className="card-img-top"
              alt={post.title}
              style={{
                width: "100%",
                maxHeight: "250px",
              }}
            />
          )}

          {!post.banner && post.image && (
            <img
              src={post.image}
              className="card-img-top"
              alt={post.title}
              style={{
                display: "block",
                width: "100%",
                maxHeight: "250px",
                top: "0",
              }}
            />
          )}
          <div className="card-body d-flex flex-column gap-3">
            <div className="row">
              <h3
                className="card-title text-primary"
                style={{ textAlign: "left" }}
              >
                {post.title}
              </h3>
              <p className="card-text text-muted">
                {new Date(post.date).toLocaleDateString()}
              </p>
            </div>

            <div className="row">
              <div className="d-flex flex-wrap gap-3">
                {post.hashtags.map((tag, index) => (
                  <div
                    className="hashtag-link"
                    key={index}
                    onClick={() =>
                      window.open(
                        `https://www.facebook.com/hashtag/${tag}?locale=en_GB`,
                        "_blank"
                      )
                    }
                  >
                    <span className="hashtag-small dark">#{tag}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="row">
              <div className="col-auto">
                <NavLink to={`/post/${post.id}`}>
                  <button className="primary">Read More!</button>
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      ))}

      {/* <div className="d-flex justify-content-between mt-4">
        <button
          className="secondary square"
          disabled={page <= 1}
          onClick={() => setPage(page - 1)}
        >
          <i className="material-icons md-32 icon" style={{ transform: "translateX(-2px)"}}>arrow_back_ios_new</i>
        </button>
        <span>
          Page {page} of {totalPages}
        </span>
        <button
          className="secondary square"
          disabled={page >= totalPages}
          onClick={() => setPage(page + 1)}
        >
          <i className="material-icons md-32 icon">arrow_forward_ios</i>
        </button>
      </div> */}
    </div>
  );
};

export default BlogIndex;
